
<!-- <app-navbar></app-navbar> -->
<main class="background-preview animated fadeIn slow">
    <div class="main-view">
        <mdb-breadcrumb *ngIf="user.role == 'Admin' || user.role == 'Trabajador EMT'" customClass="white" class="breadcrumbs mt-3 mb-0 pb-0">
            <mdb-breadcrumb-item class="breadcrumbs-disabled" routerLink="/rep/companies"><i class="fa-solid fa-house mr-1"></i>Compañias</mdb-breadcrumb-item>
            <mdb-breadcrumb-item routerLink="/rep/unitsEmt" class="breadcrumbs-disabled">Unidades</mdb-breadcrumb-item>
            <mdb-breadcrumb-item class="active" class="breadcrumbs-enabled">Servicios</mdb-breadcrumb-item>
        </mdb-breadcrumb>

        <mdb-breadcrumb *ngIf="user.role == 'Cliente' " customClass="white" class="breadcrumbs mt-3 mb-0 pb-0">
            <mdb-breadcrumb-item routerLink="/rep/units" class="breadcrumbs-disabled"><i class="fa-solid fa-house mr-1"></i>Unidades</mdb-breadcrumb-item>
            <mdb-breadcrumb-item class="active" class="breadcrumbs-enabled">Servicios</mdb-breadcrumb-item>
        </mdb-breadcrumb>
        <div class="component-div">
            <div class="image-container">
                <img src="/assets/aplications.svg" width="130px" alt="image">
                <h1 class="text-center title-image p-0 m-0">Servicios {{ unit.name | titlecase }}</h1>
            </div>
    
            <div class="card-columns container pb-5 card-config">
    
                <app-cards [objectx]="objectx" [index]="i+1" *ngFor="let objectx of servicesUnit; let i=index"></app-cards>
    
            </div>
        </div>
    </div>
</main>

<ngx-spinner bdColor = "rgba(3,128,128,0.7)" size = "medium" color = "#fff" type = "ball-spin-clockwise" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>